import { RefObject, useLayoutEffect, useState } from "react";

export function useStuck(
  ref: RefObject<HTMLElement | null>,
  offset: number,
  enabled = true
): boolean {
  const [stuck, setStuck] = useState(false);

  // Layout, not effect: a bar mounted while the page is already scrolled has to
  // know it is stuck before it paints, or it shows a frame inset and rounded.
  useLayoutEffect(() => {
    const el = enabled ? ref.current : null;
    if (!el) return;

    let frame = 0;
    const measure = () => {
      frame = 0;
      setStuck(el.getBoundingClientRect().top <= offset);
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };

    measure();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule, { passive: true });
    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [ref, offset, enabled]);

  return stuck;
}
